import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HelpService } from 'src/app/services/help.service';

@Component({
  selector: 'app-automatic-invest',
  templateUrl: './automatic-invest.component.html',
  styleUrls: ['./automatic-invest.component.scss'],
})
export class AutomaticInvestComponent implements OnInit {

  public investForm: UntypedFormGroup;
  public ratingForm: UntypedFormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorAmount = false;

  step = 1;
  questions = [
    { text: 'Qué es una estrategia de inversión?', index: 1 },
    { text: 'Cuando recibiré dinero de mis inversiones?', index: 2 },
    { text: 'Puedo cancelar una estrategia de inversion?  ', index: 3 },
  ];
  prevBtn = 'secondary-disabled';

  infData = {
    profEstim: [{ data: '5%', selected: false }, { data: '7%', selected: true }, { data: '>7%', selected: false }],
    reinvestMoney: false,
    investAnyRating: false,
    investAnyProf: false,
    investAnyDistrib: false,
    distribType: [
      { data: 'Autoconsumo', selected: true },
      { data: 'Red', selected: false }
    ],
    investFrecuency: [
      { data: 'Mensual', selected: false },
      { data: 'Trimestral', selected: true },
      { data: 'Anual', selected: false }
    ],
    investType: [
      { data: '1 año', selected: true },
      { data: '5 años', selected: false },
      { data: '10 años', selected: false }
    ],
    investPeriod: [
      { data: `< 1 año`, selected: true },
      { data: `< 20 años`, selected: false },
      { data: `> 20 años`, selected: false }
    ],
    paymentType: [
      {
        data: 'bank',
        selected: true,
        title: 'Tarjeta bancaria',
        subtitle: 'Cargos recurrentes *mensualmente* en tu tarjeta'
      },
      {
        data: 'transfer',
        selected: false,
        title: 'Wallet',
        subtitle: 'Cargos recurrentes *mensualmente* en tu wallet'
      }
    ],
    getBenefictsRec: false,
    termsandConditions: false
  };

  strategyData: any;
  profselected: string;
  capital: string;
  distribution: string;
  investTime: string;
  investFrecuency: string;
  totalInvest = '0';

  image = 6;
  text = '<h2>¡Enhorabuena!</h2> <p>Has creado tu estrategia de inversión. De ahora en adelante invertiremos por ti en todos los proyectos que cuadren tus preferencias de inversión. En cualquier momento podras cambiar o cancelar tu estrategia de inversión desde el area del portfolio</p>';


  constructor(private helpService: HelpService, private translate: TranslateService, public chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.investForm = new UntypedFormGroup({
      annualInvest: new UntypedFormControl('', [Validators.required])
    });
    this.ratingForm = new UntypedFormGroup({
      aType: new UntypedFormControl('', []),
      bType: new UntypedFormControl('', []),
      cType: new UntypedFormControl('', [])
    });
    this.getStrategydata();
    this.chdRef.detectChanges();
  }

  getInvestValue() {
    this.totalInvest = this.investForm.controls.annualInvest.value;
    this.chdRef.detectChanges();
  }

  questionClicked(index) {
    this.helpService.openHelp('second', index, 'AUTOMATIC_INVEST');
    this.chdRef.detectChanges();
  }

  prev() {
    if (this.step > 1) {
      this.step--;
      this.prevBtn = 'secondary';
    }
    if (this.step === 1) {
      this.prevBtn = 'secondary-disabled';
    }
    this.chdRef.detectChanges();
  }

  next() {
    this.step++;
    this.prevBtn = 'secondary';
    this.chdRef.detectChanges();
  }

  goToStep(stp) {
    this.step = stp;
    this.prevBtn = 'secondary';
    this.chdRef.detectChanges();
  }

  selectType(arr, param) {
    this.infData[arr].forEach(element => {
      element.selected = (element.data === param) ? true : false;
    });
    this.getStrategydata();
    this.chdRef.detectChanges();
  }

  selectChecks(ckeck) {
    this.infData[ckeck] = !this.infData[ckeck];
    this.getStrategydata();
    this.chdRef.detectChanges();
  }

  getStrategydata() {

    this.infData.profEstim.forEach(element => {
      if (element.selected) {
        this.profselected = element.data;
      }
    });
    this.infData.distribType.forEach(element => {
      if (element.selected) {
        this.distribution = element.data;
      }
    });
    this.infData.investType.forEach(element => {
      if (element.selected) {
        this.investTime = element.data;
      }
    });
    this.infData.investFrecuency.forEach(element => {
      if (element.selected) {
        this.investFrecuency = element.data;
      }
    });
  }

}
